// @flow
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from 'components/App';
import ScrollToTop from 'components/common/ScrollToTop';
import store from 'store';

const Root = () => (
  <Provider store={store}>
    <BrowserRouter>
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </Provider>
);

export default Root;



// WEBPACK FOOTER //
// ./src/Root.js